/* unplugin-vue-components disabled */import { render } from "./HeaderPc.vue?vue&type=template&id=4b4df1d8&scoped=true"
import script from "./HeaderPc.vue?vue&type=script&lang=js"
export * from "./HeaderPc.vue?vue&type=script&lang=js"

import "./HeaderPc.vue?vue&type=style&index=0&id=4b4df1d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4df1d8"]])

export default __exports__